/* @flow */

import type { Point } from './Common';

export default class LineSegment {
  from: Point;
  to: Point;
  slope: ?number;
  constant: ?number;

  // use setter to avoid mallocing new LineSegments
  setFromTo(from: Point, to: Point) {
    const width = to.x - from.x;
    const height = to.y - from.y;

    let slope = null;
    let constant = null;
    if (width !== 0) {
      slope = height / width;
      constant = to.y - slope * to.x;
    }

    this.from = from;
    this.to = to;
    this.slope = slope;
    this.constant = constant;
  }

  containsPointInSquare(point: Point) {
    const containsHorizontal =
      this.from.x < this.to.x
        ? this.from.x <= point.x && point.x <= this.to.x
        : this.from.x >= point.x && point.x >= this.to.x;
    const containsVertical =
      this.from.y < this.to.y
        ? this.from.y <= point.y && point.y <= this.to.y
        : this.from.y >= point.y && point.y >= this.to.y;
    return containsHorizontal && containsVertical;
  }

  findIntersection(other: LineSegment): ?Point {
    if (!this.from || !other.from) {
      return null;
    }
    if (this.slope === other.slope) {
      return null;
    }
    let x, y;
    if (this.slope === null) {
      x = this.to.x;
      // $FlowFixMe
      y = other.slope * x + other.constant;
    } else if (other.slope === null) {
      x = other.to.x;
      // $FlowFixMe
      y = this.slope * x + this.constant;
    } else {
      // $FlowFixMe
      x = (other.constant - this.constant) / (this.slope - other.slope);
      // $FlowFixMe
      y = this.slope * x + this.constant;
    }
    const intersectionPoint = { x: x, y: y };
    const bothContain =
      this.containsPointInSquare(intersectionPoint) &&
      other.containsPointInSquare(intersectionPoint);
    return bothContain ? intersectionPoint : null;
  }
}



// WEBPACK FOOTER //
// ./src/LineSegment.js